module.exports = __webpack_public_path__ + "img/Rocket ship Icon - white.142c6be9.svg";